import * as Scrivito from "scrivito";
import metadataAttributes from "objs/_metadataAttributes";
import defaultPageAttributes from "objs/_defaultPageAttributes";

const ProductList = Scrivito.provideObjClass("ProductList", {
  attributes: {
    body: ["widgetlist", { only: "SectionWidget" }],
    productsNavigationTitle: "string",
    defaultProductImage: ["reference", { only: ["Image"] }],
    ...metadataAttributes,
    ...defaultPageAttributes,
  },
  extractTextAttributes: [
    "body",
    "title",
    "subtitle",
    "productsNavigationTitle",
  ],
});

export default ProductList;
